// ABOUTME: Chip above a list naming the filters it was opened with from the URL.
// ABOUTME: Its delete icon clears them, so the list shows every row again.

import { Box, Chip } from '@ds/coolshop';
import { useIntl } from 'react-intl';

import type { ListFilters } from '../utils/listFiltersParam';

type UrlListFiltersChipProps = {
    listFilters: ListFilters | null;
    onClear: () => void;
};

export function UrlListFiltersChip({ listFilters, onClear }: UrlListFiltersChipProps) {
    const { formatMessage } = useIntl();

    if (!listFilters) return null;

    return (
        <Box>
            <Chip
                label={
                    listFilters.label ??
                    formatMessage({ id: 'list-filters.chip', defaultMessage: 'Filtered list' })
                }
                onDelete={onClear}
                size="small"
                data-analytics="list-filters.clear"
            />
        </Box>
    );
}
